






import Vue from "vue";
import storeHelper from "../../../store/store-helper";
import { FavoritePatch } from "@infoland/iprova-api";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import _ from "lodash";
import { FavoritePost } from "@/store/helpers/favorite-store-helper";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "EditFavorite",
    components: {},
    props: {
        id: { type: Number, required: true },
        title: { type: String, required: true },
        hyperlinkId: { type: String, required: false },
        cancelFunction: { type: Function }
    },
    data: function () {
        return {
            cancel: this.cancelFunction,
            valid: true,
            itemTitle: this.title
        };
    },
    created() {
        this.registerHandlers({ ok: this.saveFavorite, cancel: this.onCancel });
    },
    beforeDestroy() {
        this.clearHandlers();
    },
    methods: {
        validateForm() {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
            if (!formIsValid) this.focusOnFirstInvalidElement();
            return formIsValid;
        },
        focusOnFirstInvalidElement() {
            const formComponent = this.$refs.form as Vue;
            const firstInvalidElement = _.find(formComponent.$children, ["valid", false]);
            firstInvalidElement.focus();
        },
        async saveFavorite() {
            let result = false;
            if (this.validateForm()) {
                this.valid = false;

                if (this.id == 0) {
                    const favoritePost = {
                        description: this.itemTitle,
                        hyperlink_id: this.hyperlinkId
                    };
                    result = await storeHelper.favoriteItemsStore.createFavorite(favoritePost as FavoritePost);
                } else {
                    const favoritePatch = {
                        description: this.itemTitle
                    };
                    result = await storeHelper.favoriteItemsStore.updateFavorite(this.id, favoritePatch as FavoritePatch);
                }

                if (result) {
                    this.cancel();
                }
            }
            return false;
        },
        required() {
            return v => !!v || `${this.$t("validation.isRequired")}`;
        },
        async onCancel() {
            this.cancel();
            return false;
        }
    }
});
